import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { usePartnerShares } from '../context/PartnerSharesContext';

const PartnerSharesHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerShares();

  const title = data.isCoOwner
    ? t('CoOwnershipDetail')
    : t('ParticipationDetail');

  return <h6 className="overline-title-alt mb-2">{title}</h6>;
};

export default PartnerSharesHeader;
